import { ErrorIcon } from "../../icons/ErrorIcon";
import { classNames } from "../../utils/classNames";

export type FormErrorProps = {
	error: string;
	id?: string;
	className?: string;
};

export const FormError = ({ error, id, className }: FormErrorProps) => {
	return (
		<div
			aria-live="assertive"
			id={id}
			className={classNames("flex items-start gap-1 text-critical text-sm", className)}
		>
			<span>
				<ErrorIcon className="h-5 w-5" />
			</span>
			{error}
		</div>
	);
};
